import { Icon, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Button, Text } from 'native-base';
import React from 'react';

import { useRedeemDetailsContext } from '../../contexts/redeem-details';
import { useRedeemOffersContext } from '../../contexts/redeem-offers';
import { useRedeemSummaryContext } from '../../contexts/redeem-summary';

interface HeaderContentProps {}

export const HeaderContent: React.FC<HeaderContentProps> = () => {
  const { handleRefreshRedeemDetails, lastUpdatedDate } = useRedeemDetailsContext();
  const { isLoadingRedeemOffers } = useRedeemOffersContext();
  const { isLoadingRedeemSummary, isLoadingRedeemRowsSummary } = useRedeemSummaryContext();

  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <VStack
      p={{ sm: Spacing['stack.xxs'] }}
      borderBottomWidth={{ sm: '1px' }}
      borderBottomColor="neutral.light">
      <HStack alignItems="center" justifyContent="space-between">
        {!isMobile && (
          <Text
            fontSize={Typography['fontsize.lg']}
            variant="semibold"
            color="brand.primary.principal">
            Acompanhe a boleta
          </Text>
        )}
        <HStack
          alignItems="center"
          justifyContent="space-between"
          space={Spacing['stack.xxs']}
          {...(isMobile && { w: 'full' })}>
          <HStack space={Spacing['inline.nano']}>
            <Text variant="semibold" color="neutral.medium" fontSize={Typography['fontsize.xs']}>
              Ultima atualização:
            </Text>
            <Text variant="regular" color="neutral.darkest" fontSize={Typography['fontsize.xs']}>
              {lastUpdatedDate}
            </Text>
          </HStack>
          <Button
            variant="textLink"
            onPress={handleRefreshRedeemDetails}
            isDisabled={
              isLoadingRedeemSummary || isLoadingRedeemOffers || isLoadingRedeemRowsSummary
            }
            rightIcon={
              <Icon name="Refresh" size="xxxs" color={Color['brand.tertiary.principal']} />
            }
            _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}>
            Atualizar
          </Button>
        </HStack>
      </HStack>
    </VStack>
  );
};
